import { Card, RadialWheel } from '@joor/design-system'
import styled from 'styled-components'

import { formatNumberWithCustomSeparators } from 'utils/formatters'

import { EMPTY_VALUE } from 'shop/products/traits'

import { OrderData } from '../../Overview'

export enum OrderMinimumsWidgetTestIds {
  OrderUnitsChart = 'order-units-chart',
  OrderValueChart = 'order-value-chart',
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
`

const StyledRadialWheel = styled(RadialWheel)`
  line-height: normal; // TODO: fix this in the DS?
`

const StyledCard = styled(Card)`
  min-width: 320px;
  section {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

type Props = {
  className?: string
  testId?: string
  minAmount: number
  minUnits: number
  quantity: OrderData['quantity']
  wholesaleTotal: OrderData['wholesaleTotal']
  currency?: NonNullable<OrderData['priceType']>['currency']
  loading: boolean
}

export const OrderMinimumsWidget = ({
  className = '',
  testId,
  minAmount,
  minUnits,
  quantity,
  wholesaleTotal,
  currency,
  loading,
}: Props) => {
  const formatOrderValue = (value: number) =>
    formatNumberWithCustomSeparators(
      value,
      currency?.thousands_separator || undefined,
      currency?.decimal_separator || undefined,
      currency?.decimals,
    )

  const currencyCode = currency?.code ?? EMPTY_VALUE

  return (
    <StyledCard className={className} testId={testId} title="Order Minimums">
      <Container>
        <StyledRadialWheel
          testId={OrderMinimumsWidgetTestIds.OrderValueChart}
          quantityLabel={formatOrderValue(wholesaleTotal - (minAmount ?? 0))}
          legendLabel={`${currencyCode} from minimum`}
          baseWheelTooltip={`Order Value Minimum: ${formatOrderValue(
            minAmount ?? 0,
          )} ${currencyCode}`}
          progressWheelTooltip={`Current Order Value: ${formatOrderValue(
            wholesaleTotal,
          )} ${currencyCode}`}
          currentValue={wholesaleTotal}
          targetValue={minAmount ?? 0}
          isLoading={loading}
        />
        <StyledRadialWheel
          testId={OrderMinimumsWidgetTestIds.OrderUnitsChart}
          legendLabel="Units from minimum"
          baseWheelTooltip={`Order Unit Minimum: ${minUnits}`}
          progressWheelTooltip={`Current Total Units: ${quantity}`}
          currentValue={quantity}
          targetValue={minUnits ?? 0}
          isLoading={loading}
        />
      </Container>
    </StyledCard>
  )
}
